import type { ExploreFilter } from '../../api/server/explore';
import type { MessageFilters, FilterField } from './useMessageFilters';

const EMPTY_SELECTION_SENTINEL = '__empty_selection__';

const FIELD_MAP: Record<FilterField, keyof ExploreFilter> = {
  channels: 'channel_ids',
  sourceTypes: 'source_types',
  deviceIds: 'device_ids',
  feedIds: 'feed_ids',
  talkgroups: 'talkgroups',
  talkgroupTags: 'talkgroup_tags',
  radioIds: 'radio_ids',
  speakerIds: 'speaker_ids',
  tags: 'tags'
};

type ExcludeKey = keyof NonNullable<ExploreFilter['exclude']>;

const EXCLUDE_MAP: Partial<Record<FilterField, ExcludeKey>> = {
  channels: 'channel_ids',
  sourceTypes: 'source_types',
  deviceIds: 'device_ids',
  talkgroupTags: 'talkgroup_tags',
  radioIds: 'radio_ids',
  speakerIds: 'speaker_ids',
  tags: 'tags'
};

interface ConvertOptions {
  orgId: string;
  start: string;
  end: string;
  keyword?: string;
}

export function filtersToExploreFilter(
  filters: MessageFilters,
  opts: ConvertOptions
): ExploreFilter {
  const result: ExploreFilter = {
    org_id: opts.orgId,
    start: opts.start,
    end: opts.end
  };

  if (opts.keyword && opts.keyword.trim() !== '') {
    result.keyword = opts.keyword;
  }

  if (filters.emergency) {
    result.emergency_only = true;
  }

  const exclude: NonNullable<ExploreFilter['exclude']> = {};

  for (const field of Object.keys(FIELD_MAP) as FilterField[]) {
    const { values, mode } = filters[field];
    const cleaned = values.filter((v) => v !== EMPTY_SELECTION_SENTINEL);
    if (cleaned.length === 0) continue;

    if (mode === 'include') {
      (result as Record<string, unknown>)[FIELD_MAP[field]] = cleaned;
    } else {
      const excludeKey = EXCLUDE_MAP[field];
      if (excludeKey) {
        (exclude as Record<string, unknown>)[excludeKey] = cleaned;
      }
    }
  }

  if (Object.keys(exclude).length > 0) {
    result.exclude = exclude;
  }

  return result;
}
